import React from "react";
import Image from "../assets/hero.png";
import { Link } from "react-router-dom";

const Hero = () => {
   return(
    <div id="home" className='w-full py-16 px-4 text-white'>
        <div className='max-w-[1240px] mx-0 grid md:grid-cols-2'>
            <img className='w-[500px] ml-0 my-4' src={Image} alt='/' />
            <div className='flex flex-col justify-center'>
                <p className='text-[#F08000] font-bold '>WELCOME TO YEE SHIN THIPAW</p>
                <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold py-2'>Your Trustworthy Shop Ever</h1>
               <p className="lg:py-14 md:py-10 py-4">
                Yee Shin Thipaw သည်ရှမ်းပြည်မြောက်ပိုင်း သီပေါမြို့တွင်တည်ရှိပြီး လျှပ်စစ်ပစ္စည်း
                နှင့် အိမ်အသုံးအဆောင်ပစ္စည်းများကို လက်လီလက်ကားဖြန့်ချီရောင်းချပေးသော 
                စီးပွါးရေးလုပ်ငန်းတစ်ခုဖြစ်ပါသည်။
               </p>
               
               <a href="https://www.facebook.com/yeeshin.Hsipaw" target="blank">
                   <button className='block bg-[#F08000] text-black w-[200px] rounded-md font-medium my-6 mx-auto md:mx-0 py-3'>Buy Now</button>
               </a> 
            </div>
        </div>
    </div>
   )
}

export default Hero;
